import React, {useState, useEffect} from 'react';
import './authentication.css';
import axios from 'axios';
import BackIcon from '../../img/back.svg';
import {toast, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {Button} from 'rsuite';
import AuthService from "../../services/auth.service";
import CampaignService from "../../services/campaign.service";
import MessageHandle from "../../services/MessageHandle";

const APP_URL = process.env.APP_URL;

const Authentication = () => {
    const [containerClass, setContainerClass] = useState('');
    const [mobile, setMobile] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [step, setStep] = useState('mobile-step');
    const [minutes, setMinutes] = useState(1);
    const [seconds, setSeconds] = useState(30);
    const [isLoading, setIsLoading] = useState(false);
    const [information, setInformation] = useState({
        name: '',
        surname: '',
    });
    const [mobileSubmitButtonStatus, setMobileSubmitButtonStatus] = useState(false);
    const [verificationSubmitButtonStatus, setVerificationSubmitButtonStatus] = useState(false);
    const [informationSubmitButtonStatus, setInformationSubmitButtonStatus] = useState(false);

    if (AuthService.getCurrentUser()) {
        entranceAfterLogin();
        // window.location.replace('/');
        return (<></>);
    }

    useEffect(() => {
        window.addEventListener('popstate', function (event) {
            handleBrowserBack();
        });

    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                } else {
                    setSeconds(59);
                    setMinutes(minutes - 1);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    return (
        <div className={`container ${containerClass}`}>
            <div className="form-container">
                {step === 'mobile-step' ? mobileStep() : ''}
                {step === 'verification-step' ? verificationStep() : ''}
                {step === 'registration-step' ? registrationStep() : ''}

            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );


    function backButton() {
        return (
            <button className="btn-back" onClick={handleBack}>
                <img src={BackIcon} alt="back"/>
            </button>
        );
    }

    function mobileStep() {
        return (
            <>
                <div className="authentication-form mobile-step">
                    <label>لطفا شماره موبایل خود را وارد کنید</label>
                    <input name="mobile"
                           type="text"
                           inputMode="numeric"
                           id="mobile"
                           value={mobile}
                           autoComplete="off"
                           minLength={11}
                           maxLength={11}
                           onFocus={onFocus}
                           onBlur={onBlur}
                           onKeyDown={e => e.key === 'Enter' ? handleSendOTP() : null}
                           onChange={e => handleChangeMobile(e)}/>

                </div>
                <div className="form-bottom form-bottom-this">
                    <Button className="next-button" appearance={isLoading ? 'default' : 'primary'}
                            onClick={handleSendOTP}
                            disabled={!mobileSubmitButtonStatus}
                            loading={isLoading}
                            block>
                        ادامه
                    </Button>
                </div>
            </>
        );
    }

    function verificationStep() {

        return (
            <>
                {backButton()}

                <div className="authentication-form verification-step">
                    <label>کد 4 رقمی ارسال شده به شماره {mobile} را وارد کنید</label>
                    <button className="btn btn-mobile-step " onClick={handleBack}>تغییر شماره موبایل</button>
                    <input name="code"
                           id="code"
                           autoFocus={true}
                           autoComplete="one-time-code"
                           inputMode="numeric"
                           minLength={4}
                           maxLength={4}
                           onBlur={onBlur}
                           onFocus={onFocus}
                           onKeyDown={e => e.key === 'Enter' ? handleVerifyOTP() : null}
                           onChange={e => handleChangeVerificationCode(e)}/>

                    <div className="resend-text">
                        {seconds > 0 || minutes > 0 ? (
                            <div className="text-right">
                                <div className="d-inline" style={{marginLeft: '1rem'}}>پیامکی
                                    دریافت نکرده اید؟
                                </div>
                                <div className="d-inline" style={{marginLeft: '.2rem', marginRight: '.2rem'}}>
                                    {minutes < 10 ? `0${minutes}` : minutes}:
                                    {seconds < 10 ? `0${seconds}` : seconds}
                                </div>

                                تا ارسال مجدد
                            </div>
                        ) : (
                            <Button className="btn" onClick={handleSendOTP} loading={isLoading}>ارسال مجدد</Button>
                        )}
                        <div className="terms-and-rules">ادامه به منزله پذیرفتن <b><a href="https://changaal.com/rules/">شرایط و قوانین</a></b> چنگال است.</div>

                    </div>
                </div>

                <div className="form-bottom">
                    <Button className="next-button" appearance={isLoading ? 'default' : 'primary'}
                            onClick={handleVerifyOTP}
                            disabled={!verificationSubmitButtonStatus}
                            loading={isLoading}
                            block>
                        ارسال
                    </Button>
                </div>
            </>
        );
    }

    function registrationStep() {
        return (
            <>
                {backButton()}

                <div className="authentication-form registration-step">
                    <label>نام خود را وارد کنید</label>
                    <input name="name"
                           id="name"
                           autoComplete="off"
                           autoFocus={true}
                           onBlur={onBlur}
                           onFocus={onFocus}
                           placeholder="نام"
                           onChange={e => handleChangeInformation(e)}/>

                    <label style={{marginTop: '1.5rem'}}>نام خانوادگی خود را وارد کنید</label>
                    <input name="surname"
                           id="surname"
                           autoComplete="off"
                           autoFocus={false}
                           onBlur={onBlur}
                           onFocus={onFocus}
                           placeholder="نام خانوادگی"
                           onKeyDown={e => e.key === 'Enter' ? handleRegister() : null}
                           onChange={e => handleChangeInformation(e)}/>
                </div>

                <div className="form-bottom">
                    <Button appearance={isLoading ? 'default' : 'primary'}
                            onClick={handleRegister}
                            loading={isLoading}
                            block>
                        ادامه
                    </Button>
                </div>
            </>
        );
    }


    function handleBrowserBack() {
        setStep('mobile-step');
        addUrlParameter('p', '')
        addUrlParameter('s', '')
    }

    function handleBack() {
        switch (step) {
            case 'mobile-step':
                setContainerClass('');
                break;

            case 'verification-step':
                setContainerClass('');
                setStep('mobile-step');
                break;

            case 'registration-step':
                setContainerClass('');
                setStep('mobile-step');
                break;

            case 'notfound':
                setContainerClass('');
                setStep('notfound');
                break;
        }
    }

    function handleKeyPress(e) {
        if (e.key === 'Enter') {
            handleRegister();
        }
    }

    function handleChangeInformation(event) {
        let informationChange = {...information};
        informationChange[event.target.name] = event.target.value;
        setInformation(informationChange);
    }

    function handleChangeMobile(event) {
        setMobile(event.target.value);

        if (event.target.value.length === 11) {
            setMobileSubmitButtonStatus(true);
        } else {
            setMobileSubmitButtonStatus(false);
        }
    }

    function handleChangeVerificationCode(event) {
        setVerificationCode(event.target.value);

        if (event.target.value.length === 4) {
            handleVerifyOTP(event.target.value);
            setVerificationSubmitButtonStatus(true);
        } else {
            setVerificationSubmitButtonStatus(false);
        }
    }

    function onBlur() {
        setContainerClass('');
    }

    function onFocus() {
        setContainerClass('on-keyboard');
    }

    function handleSendOTP() {
        if (isLoading) {
            return false;
        }

        setMinutes(1);
        setSeconds(30);

        const body = {
            mobile: mobile,
        };

        setIsLoading(true);

        axios.post(`${APP_URL}/api/authentication/send-otp`, body)
            .then(function (response) {
                setIsLoading(false);
                setContainerClass('');
                setStep('verification-step');
                addUrlParameter('p', 'mobile-step');
            })
            .catch(function (error) {
                console.log(error);
                //throw new Error('Hulk smash!'.error);
                setIsLoading(false);

                if (!error.response) {
                    handleNotfound();
                    return false;
                }
                MessageHandle.error(error)
            });
    }

    function handleRegister() {
        if (isLoading) {
            return false;
        }

        setMinutes(1);
        setSeconds(30);

        let body = {
            mobile: mobile,
            code: verificationCode,
            name: information.name,
            surname: information.surname,
        };

        const campaignParameters = CampaignService.get();

        body = {...body, ...campaignParameters}

        setIsLoading(true);

        axios.post(`${APP_URL}/api/authentication/register`, body)
            .then(function (response) {
                successAuth(response.data)
            })
            .catch(function (error) {
                setIsLoading(false);

                if (!error.response) {
                    handleNotfound();
                    return false;
                }
                MessageHandle.error(error)
            });
    }

    function handleVerifyOTP(val = null) {
        if (isLoading) {
            return false;
        }

        const body = {
            mobile: mobile,
            code: val ? val : verificationCode,
        };

        setIsLoading(true);

        axios.post(`${APP_URL}/api/authentication/verify-otp`, body)
            .then(function (response) {
                if (!response.data.status) {
                    setIsLoading(false);
                    toast.error(response.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    return false;
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'success_auth_otp',
                });

                if (response.data.user) {
                    successAuth(response.data)
                } else {
                    setIsLoading(false);
                    setContainerClass('');
                    setStep('registration-step');
                    addUrlParameter('s', 'mobile-step');
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                if (!error.response) {
                    handleNotfound();

                    return false;
                }
                MessageHandle.error(error)
            });
    }

    function successAuth(data) {
        localStorage.setItem("user", JSON.stringify(data));

        toast.success(data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
        entranceAfterLogin();
        // window.location.replace('/');
    }

    function addUrlParameter(key, value) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);

        let kvp = window.location.search.substr(1).split('&');
        if (kvp[0] === '') {
            const path = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + key + '=' + value;
            window.history.pushState({path: path}, '', path);

        } else {
            let i = kvp.length;
            let x;
            while (i--) {
                x = kvp[i].split('=');

                if (x[0] === key) {
                    x[1] = value;
                    kvp[i] = x.join('=');
                    break;
                }
            }

            if (i < 0) {
                kvp[kvp.length] = [key, value].join('=');
            }

            const refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + kvp.join('&');
            window.history.pushState({path: refresh}, '', refresh);
        }
    }

    function getUrlParameter(key) {
        const url = new URL(window.location.href);
        return url.searchParams.get(key);
    }

    function handleNotfound() {
        localStorage.setItem("error", 'PageNotFound');
        setIsLoading(false);
        //setStep('notfound');
        window.location.href = '';
    }

    function entranceAfterLogin() {
        let url = '/';

        if (AuthService.getHasActiveMeal()) {
            url = '/subscriptions/active-subscription';
        }else if (AuthService.getHasWeighing()) {
            url = '/subscriptions';
        }
        window.location.replace(url);
    }
}

export default Authentication;
